/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import React, { FC } from "react";

import { LineSeparator } from "@/components/atoms";
import { UserState } from "@/shared/domain";
import { isABroker, useAuth } from "@/shared/hooks";

import { AddBrokerButton } from "./AddBrokerButton/AddBrokerButton";
import CurrentBrokerInfo from "./CurrentBrokerInfo/CurrentBrokerInfo";

type MyBrokerSelectorMobileProps = {
    currentStateBroker: MyBrokerApi.Broker;
    UnselectedAvailableBrokers: React.ReactElement[];
    handleClickAddress: () => void;
    handleClickPhone: () => void;
    handleClickEmail: () => void;
    handleClickUrl: () => void;
    hideSeeMore: boolean;
};

const MyBrokerSelectorMobile: FC<MyBrokerSelectorMobileProps> = ({
    currentStateBroker,
    UnselectedAvailableBrokers,
    handleClickAddress,
    handleClickPhone,
    handleClickEmail,
    handleClickUrl,
    hideSeeMore,
}) => {
    const { userState } = useAuth();
    return (
        <ul className="MyBrokerSelectorMobile">
            <li className="broker-name">{currentStateBroker.brokerName}</li>

            <CurrentBrokerInfo
                hideSeeMore={hideSeeMore}
                handleClickAddress={handleClickAddress}
                handleClickUrl={handleClickUrl}
                handleClickEmail={handleClickEmail}
                handleClickPhone={handleClickPhone}
                currentStateBroker={currentStateBroker}
            />
            {UnselectedAvailableBrokers}
            {!isABroker() && userState !== UserState.PENDING && (
                <>
                    <LineSeparator />
                    <AddBrokerButton />
                </>
            )}
        </ul>
    );
};

export default MyBrokerSelectorMobile;
